import React, { memo } from 'react';
import PropTypes from 'prop-types';

const MetadataDescription = ({ description }) => {

    if (!description) {

        return null;

    }
    
    return (
        <p className='metadata__description'>{description}</p>
    );

};

MetadataDescription.propTypes = {
    description: PropTypes.string,
};

export default memo(MetadataDescription);
